import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* Router Modules */
// import adminuserRouter from './modules/adminuser'
import carBrandRouter from './modules/carbrand'
import priceRouter from './modules/price'
import jxsRouter from './modules/jxs'
import jxsShopRouter from './modules/jxsShop'
import jxsAccountRouter from './modules/jxsAccount'
import permissonRouter from './modules/permission'
import jxcRouter from './modules/jxc'
import warrantyRouter from './modules/warranty'
import smsRouter from './modules/sms'
import productRouter from './modules/product'
import warrantyOldRouter from './modules/warranty_old'
import minipUserRouter from './modules/user'
import syWarrantyRouter from './modules/syWarranty'
import accessLogRouter from './modules/access_log'

import cmsRouter from './modules/cms'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/auto-login',
    component: () => import('@/views/login/auto-login'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },

  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: () => import('@/views/dashboard/index'),
      meta: { title: '控制面板', icon: 'dashboard', affix: true }
    }]
  }

]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

export const asyncRoutes = [
  // cmsRouter
  cmsRouter,
  carBrandRouter,
  priceRouter,

  // crmRouter
  jxcRouter,
  warrantyRouter,
  syWarrantyRouter,
  jxsRouter,
  jxsShopRouter,
  jxsAccountRouter,
  smsRouter,
  warrantyOldRouter,
  minipUserRouter,
  productRouter,
  permissonRouter,
  // adminuserRouter
  accessLogRouter,
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
